import styled from 'styled-components';

import {SOURCING_CARD_GEOMETRY} from './constants/SOURCING_CARD_GEOMETRY';

/**
 * Stats of a sourcing card laid out in as many equal columns as fit the card, so the cells wrap
 * instead of overlapping in a narrow card. `min(100%, ...)` keeps one column inside a card narrower
 * than the minimum. The platform `Grid` only supports a fixed column count.
 */
export const CardStatsGrid = styled.div<{$enhancedSurfaces: boolean}>`
  display: grid;
  /* TODO T20-140975 Extend platform's Grid with a minimal column width (auto-fit) and use it here */
  grid-template-columns: repeat(
    auto-fit,
    minmax(min(100%, ${({theme}) => theme.getSize(SOURCING_CARD_GEOMETRY.statMinWidth)}), 1fr)
  );
  gap: ${({theme}) => theme.getSize(2)};
  min-width: 0;
  ${({$enhancedSurfaces, theme}) =>
    $enhancedSurfaces &&
    `padding-top: ${theme.getSize(3)}; border-top: 1px solid ${theme.colors.general.separator};`}
`;
